module.exports = __webpack_public_path__ + "static/media/PakCons.b3de92e2.topojson";